import React from 'react';
import { Link  } from 'react-router-dom';
import { Button, Col,  Row } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";
import {ImageUrl} from '../../../../../Helpers/request';
const DiamondCollectionVideo = () => {
    return (
        <>

            <div className="diamond_video12">
                <div className="clearfix">
                    <div className="diamond_video">

                        <Row>
                            <Col lg={6}>
                                <div className="qode_video_box">

                                    {/* <Button to="" className="qode_video_image popup-vimeo" onClick={() => setOpen(true)}>
                                        <LazyLoadImage src={DiamondImg1} alt="diamond" />
                                        <span className="qode_video_box_button_holder" >
                                            <span className="qode_video_box_button">
                                                <span className="qode_video_box_button_arrow">
                                                </span>
                                            </span>
                                        </span>
                                    </Button> */}

                                    <Button  className="qode_video_image popup-vimeo" >
                                      <Link to="/diamonds"> <LazyLoadImage src={`${ImageUrl}theme/venice/diamond_screen.webp`} alt="diamond" /> </Link>  
                                        {/* <span className="qode_video_box_button_holder" >
                                            <span className="qode_video_box_button">
                                                <span className="qode_video_box_button_arrow">
                                                </span>
                                            </span>
                                        </span> */}
                                    </Button>
                                </div>

                                {/* <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="L61p2uyiMSo" onClose={() => setOpen(false)} /> */}

                            </Col>
                            <Col lg={4}>
                                <div className="content_section">
                                <LazyLoadImage  className="Dfl_dc_img" alt="diamond" src={`${ImageUrl}theme/venice/pendaant_diamonds.png`} />
                                    <h2>Diamond Collection</h2>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </div>
            </div>


         



        </>
    )
}

export default DiamondCollectionVideo;